import { Box, Paper, Link } from "@mui/material";
import { useMemo, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useTranslate } from "../components/Translate/TranslateContext";
import SetupBar from "../components/Layout/SetupBar";
import AnimatedIcons from "../components/Layout/AnimatedIcons";

import FarmRegistration from "../components/Register/FarmRegistration";
import DataSetup from "../components/Register/DataSetup";

import useDataPrepPolling from "../hooks/useDataPrepPolling";
import useCropRegistration from "../hooks/useCropRegistration";

export default function FarmRegister({ user, setUser }) {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();

    const [farm, setFarm] = useState({
        farm_id: null,
        farm_name: "",
        gardens: [],
        farm_status: "farm_registration",
    });

useEffect(() => {
    const farmId = location.state?.farm_id;
    const nextStatus = location.state?.farm_status;
    const startDataSetup = location.state?.start_data_setup === true;

    if (!farmId) return;

    setFarm(prev => ({
        ...prev,
        farm_id: farmId,
        farm_status: startDataSetup
            ? "data_setup"
            : nextStatus || prev.farm_status,
    }));
}, [location.state]);
useEffect(() => {
    if (farm.farm_status === "active") {
        navigate("/dashboard", {
            replace: true,
            state: null,
        });
    }
}, [
    farm.farm_status,
    navigate,
]);

    const { bootstrapRun, retryRun, stopPolling } = useDataPrepPolling({
        user,
        farm_id: farm.farm_id,
        status: farm.farm_status,
        setFarm
    });

    const { cropTypes, cropVarieties } = useCropRegistration({
        cropType: user?.crop_type,
    });

    const handleBack = () => {
        stopPolling();
        navigate(-1);
    };

    const sharedProps = {
        user,
        cropTypes,
        cropVarieties,
        farm,
        setFarm,
    };

    const stepComponent = useMemo(() => ({
        farm_registration: <FarmRegistration {...sharedProps} />,
        data_setup: (
            <DataSetup
                farmId={farm.farm_id}
                run={bootstrapRun}
                onRetry={retryRun}
            />
        ),
    }), [
        user,
        farm,
        cropTypes,
        cropVarieties,
        bootstrapRun,
        retryRun,
    ]);

    return (
        <Box
            sx={{
                minHeight: "calc(100vh - 70px)",
                px: { xs: 2, md: 6 },
                py: 4,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
            }}
        >
            <AnimatedIcons mono />

            <Box sx={{ width: "100%", maxWidth: 1200, zIndex: 5 }}>
                <Link
                    component="button"
                    onClick={handleBack}
                    sx={{
                        mb: 2,
                        color: "var(--color-text-inverse)",
                        textAlign: "left",
                    }}
                >
                    {translate("back")}
                </Link>

                <Paper
                    elevation={0}
                    sx={{
                        width: "100%",
                        borderRadius: 2,
                        backgroundColor: "var(--color-bg-primary)",
                        overflow: "hidden",
                    }}
                >
                    <SetupBar
                        Status={farm.farm_status}
                        Type="farm"
                    />

                    {stepComponent[farm.farm_status]}
                </Paper>
            </Box>
        </Box>
    );
}